import { memo, useCallback } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import PropTypes from 'prop-types';
import { List } from 'foundations-components/transitional/components/List';
import partial from 'transmute/partial';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineFilterListV2 = ({
  filters,
  handleFilterChange
}) => {
  const handleRenderCheckbox = useCallback(filter => {
    const label = filter.displayName;
    const eventType = filter.internalName;
    const checked = filter.selected;
    return /*#__PURE__*/_jsx(Checkbox, {
      checked: checked,
      onChange: partial(handleFilterChange, filter),
      "data-selenium-checked": checked,
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        paddingInlineStart: "300",
        textWrap: "nowrap",
        "data-selenium-test": `timeline-filter-checkbox-${eventType}`,
        children: label
      })
    }, eventType);
  }, [handleFilterChange]);
  return /*#__PURE__*/_jsx(List, {
    paddingInlineStart: "200",
    wrapChildren: true,
    children: filters.map(handleRenderCheckbox)
  });
};
TimelineFilterListV2.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.array.isRequired,
  handleFilterChange: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(TimelineFilterListV2);